/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Draft

1 = Published


 */
export type SpecificationStatus =
  (typeof SpecificationStatus)[keyof typeof SpecificationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpecificationStatus = {
  Draft: 0,
  Published: 1,
} as const;
